import graphql__c880cb85eaf9fb0da898 from "./__generated__/useTrackContactVisitMutation.graphql.ts";import graphql from 'babel-plugin-relay/macro'
import { useEffect, useState } from 'react'
import { useMutation } from 'react-relay/hooks'

import { useTrackContactVisitMutation } from './__generated__/useTrackContactVisitMutation.graphql'

const TrackContactVisitMutation = graphql__c880cb85eaf9fb0da898

/** Hook used to track a user visits time. */
const useTrackContactVisit = (hubspotContactId: string | null = null): void => {
  const [track] = useMutation<useTrackContactVisitMutation>(
    TrackContactVisitMutation,
  )
  const [tracked, setTracked] = useState(false)

  useEffect(() => {
    if (hubspotContactId && !tracked) {
      track({ variables: {} })
      setTracked(true)
    }
  }, [hubspotContactId, tracked]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useTrackContactVisit
